import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import MyTable from '../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';

import IconButton from '@material-ui/core/IconButton';

import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';

import { UserAPI } from '../../../API/user'
import { TemporaryTransferAPI } from '../../../API/temporary_transfer'

import moment from 'moment'

import { applyMaskPhone, getConsultingId } from '../../utils/utils'
import { useDispatch, useSelector } from "react-redux";

import Zoom from '@material-ui/core/Zoom';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

import { unoTheme, headerSearch, tabs } from '../../../assets/styles/unoTheme';

import { isEmpty } from "lodash";
import allActions from "../../../actions";
import CPF_AND_NAME_TEXT from "../../utils/MyHelpers/HelperTexts/SearchBar";
import MyTooltip from '../../utils/MyHelpers/MyTooltip';
import { roles } from "../../utils/user";
import { MyTab, MyTabs } from '../../utils/MyTabs';
import DefaultScrollWithHeaderContent from '../../utils/DefaultScrollWithHeaderContent';
import UnoButton from '../../utils/UnoButton';
import DetailTemporaryTransferModal from '../../modals/DetailTemporaryTransferModal';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    tabs: tabs,
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: theme.spacing(2),
        alignItems: 'center',
    },
    leftHeaderDetail: {
        display: "flex",
        alignItems: "baseline",
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },
    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },
    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableTh: {
        fontWeight: 'bold'
    },
    accordionNewClient: {
        marginBottom: theme.spacing(2),
    },
    heading: {
        display: 'flex',
        alignItems: 'center'
    },
    labelHeading: {
        marginTop: '2px'
    },
    rootForm: {
        // '& .MuiTextField-root': {
        //     margin: theme.spacing(1),
        //     width: '25ch',
        // },
        textAlign: "left",
    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },
    myDatePicker: {
        marginTop: '-6px'
    },
    selectableRow: {
        cursor: "pointer",
        '& > *': {
            borderBottom: 'unset',
            //padding: '3px 12px 3px 8px !important',
        },
        '&:nth-of-type(even)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },

        '&:hover': {
            background: unoTheme.hoverTable,
        },
        '& .MuiTableCell-sizeSmall:last-child': {
            paddingRight: '24px',
        }
    },
    fabAdd: {
        position: 'absolute',
        backgroundColor: unoTheme.mainColor,
        right: theme.spacing(4),
        bottom: unoTheme.bottomFab,
        '&:hover': {
            background: unoTheme.hoverMainButtonColor,
        }
    },
    statusChip: {
        display: 'inline-block',
        padding: '2px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        textTransform: 'uppercase',
    }
}));

function getStatusChipStyle(status) {
    switch (status) {
        case 'ATIVA':
            return { background: unoTheme.greenMoney, color: 'white' };
        case 'CONCLUIDA':
            return { background: unoTheme.mainGrayColor, color: '#616161' };
        case 'AGENDADA':
        default:
            return { background: unoTheme.warningColor, color: '#5A4B00' };
    }
}

export default function AdvisorsScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const [tabValue, setTabValue] = useState(0);
    const [appearFab, setAppearFab] = useState(true);
    const [search, setSearch] = useState("");
    let timeoutReference = null;

    const [advisors, setAdvisors] = useState([]);

    const [temporaryTransfers, setTemporaryTransfers] = useState([]);
    const [loadingTransfers, setLoadingTransfers] = useState(false);
    const [selectedTransfer, setSelectedTransfer] = useState(null);

    const currentUser = useSelector(state => state.currentUser);
    const rightContent = useSelector(state => state.rightContent);

    async function getTemporaryTransfers() {
        setLoadingTransfers(true);
        const response = await TemporaryTransferAPI.listTemporaryTransfers();
        if (response.success && response.body) {
            setTemporaryTransfers(response.body.rows || []);
        } else {
            console.error("RESPONSE ERROR: ", response.body);
            setTemporaryTransfers([]);
        }
        setLoadingTransfers(false);
    }

    async function getAdvisors() {
        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Carregando consultores...'
        }));

        let response = null;

        if (isEmpty(search)) {
            //response = await listAllAdvisors();
            //response = await listAllAdvisorsAndAdmins();
            response = await UserAPI.listAllAdvisorsAndAdminsByConsulting(getConsultingId(currentUser));
        } else {
            //response = await getAdvisorOrAdminByNameOrCPF(search);
            response = await UserAPI.getAdvisorOrAdminByNameOrCPFByConsulting(search, getConsultingId(currentUser));
        }

        if (response.success && response.body) {

            const advisorData = response.body.rows;

            if (!isEmpty(advisorData)) {
                setAdvisors(advisorData);
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
            } else {
                setAdvisors([]);
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, emptyMessage: 'Não existem consultores' }));
            }
        } else {
            console.error("RESPONSE ERROR: ", response.error);
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        }
    }

    async function updateStatusAdvisor(event, userId, status) {

        event.stopPropagation();

        const response = await UserAPI.updateStatus(userId, status);
        if (response.success) {

            getAdvisors();

        } else {
            console.log("RESPONSE ERROR: ", response.error)
        }

    }

    //form new client
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        getAdvisors();
    }, [search]);

    useEffect(() => {
        getTemporaryTransfers();
    }, []);

    useEffect(() => {
        if (rightContent && rightContent.action === 'update') {
            getTemporaryTransfers();
            dispatch(allActions.rightContentActions.setRightContent(null));
        }
    }, [rightContent]);


    const delayedChange = (searchInputValue) => {
        timeoutReference = setTimeout(() => {
            setSearch(searchInputValue);
        }, 800)
    }

    function changeSearch(event) {
        let searchInputValue = event.target.value;
        clearTimeout(timeoutReference);
        delayedChange(searchInputValue);
    }

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>
                <div className={classes.tabs}>
                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(e, newValue) => setTabValue(newValue)}>
                        <MyTab label="Consultores" value={0} />
                        <MyTab label="Gestão de férias" value={1} />
                    </MyTabs>
                </div>
                {tabValue === 0 &&
                    <div className={classes.rightHeader}>
                        <TextField id="standard-basic"
                            onChange={(event) => changeSearch(event)}
                            className={classes.inputSearch}
                            label="Nome ou CPF"
                            variant="outlined"
                            size="small" />
                        <MyTooltip
                            hasAlert
                            alertMessage={<CPF_AND_NAME_TEXT searchColumnTitle="nome do consultor" />}
                            tooltipTitle="Como funciona a busca?"
                        />
                    </div>
                }
                {tabValue === 1 &&
                    <div className={classes.rightHeader}>
                        <UnoButton
                            variant="contained"
                            type="primary"
                            startIcon={<AddIcon />}
                            onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                path: 'temporaryTransferClients',
                                data: {},
                            }))}>
                            {"Transferência temporária"}
                        </UnoButton>
                    </div>
                }
            </div>

            {tabValue === 0 &&
            <DefaultScrollWithHeaderContent>
                <MyTable
                    selectable='true'
                    stickyHeader
                    size="small">
                    <colgroup>
                        <col width="55%" />
                        {/* <col width="15%" /> */}
                        <col width="20%" />
                        <col width="15%" />
                        {/* <col width="15%" /> */}
                        <col width="10%" />
                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Nome do consultor</TableCell>
                            {/* <TableCell align="left">CPF</TableCell> */}
                            <TableCell align="left">Email</TableCell>
                            <TableCell align="center">Contato</TableCell>
                            {/* <TableCell align="center">Data cadastro</TableCell> */}
                            <TableCell align="center">Situação</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {advisors.map((row) => (
                            <>
                                <TableRow
                                    key={row.id} onClick={() => history.push(
                                        {
                                            pathname: "/administration/newAdvisor",
                                            state: { advisor: row }
                                        }
                                    )}>

                                    <TableCell align="left" component="th" scope="row">{row.name}</TableCell>
                                    {/* <TableCell align="left" >{row.cpf}</TableCell> */}
                                    <TableCell align="left" >{row.email}</TableCell>
                                    <TableCell align="center">{applyMaskPhone(row.phone_number)}</TableCell>
                                    {/* <TableCell align="center">{timeStampToPtDate(row.created_date)}</TableCell> */}
                                    <TableCell align="center">
                                        <IconButton
                                            size={'small'}
                                            onClick={(event) => updateStatusAdvisor(event, row.id, !row.active)}
                                            aria-label="show 4 new mails" color="inherit">
                                            {row.active ?
                                                <CheckCircleOutlineRoundedIcon className={classes.green} />
                                                :
                                                <HighlightOffRoundedIcon className={classes.red} />
                                            }
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            </>
                        ))}
                    </TableBody>
                </MyTable>
            </DefaultScrollWithHeaderContent>
            }

            {tabValue === 1 &&
                <DefaultScrollWithHeaderContent
                    innerLoad={loadingTransfers
                        ? { show: true, loadMessage: 'Carregando transferências...' }
                        : (temporaryTransfers.length === 0
                            ? { show: true, emptyMessage: 'Nenhuma transferência agendada' }
                            : null)}>
                    <MyTable
                        selectable='true'
                        stickyHeader
                        size="small">
                        <colgroup>
                            <col width="22%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="8%" />
                            <col width="10%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Período</TableCell>
                                <TableCell align="left">Criado por</TableCell>
                                <TableCell align="left">Origem</TableCell>
                                <TableCell align="left">Destino</TableCell>
                                <TableCell align="center">Núm. Clientes</TableCell>
                                <TableCell align="center">Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {temporaryTransfers.map((row) => (
                                <TableRow
                                    key={'temporary-transfer-' + row.id}
                                    onClick={() => setSelectedTransfer(row)}>

                                    <TableCell align="left">
                                        {moment.utc(row.period_start).format('DD/MM/YYYY')
                                            + ' - '
                                            + moment.utc(row.period_end).format('DD/MM/YYYY')}
                                    </TableCell>
                                    <TableCell align="left">{row.created_by_name || '-'}</TableCell>
                                    <TableCell align="left">{row.origin_name || '-'}</TableCell>
                                    <TableCell align="left">{row.destination_name || '-'}</TableCell>
                                    <TableCell align="center">{row.num_clients}</TableCell>
                                    <TableCell align="center">
                                        <span
                                            className={classes.statusChip}
                                            style={getStatusChipStyle(row.status)}>
                                            {row.status}
                                        </span>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </MyTable>
                </DefaultScrollWithHeaderContent>
            }

            {
                tabValue === 0
                    && currentUser
                    && currentUser.user
                    && (currentUser.user.role == "ROLE_ADMIN"
                        || currentUser.user.role == roles.superadmin.title) ?
                    <Zoom
                        in={appearFab}
                        unmountOnExit>
                        <Fab className={classes.fabAdd}
                            onClick={() => history.push('/administration/newAdvisor')}
                            color="primary" aria-label="add">
                            <AddIcon />
                        </Fab>
                    </Zoom>
                    :
                    null
            }

            <DetailTemporaryTransferModal
                open={!!selectedTransfer}
                transfer={selectedTransfer}
                handleAction={(refresh) => {
                    setSelectedTransfer(null);
                    if (refresh) {
                        getTemporaryTransfers();
                    }
                }}
            />

        </div>
    );
}



